<template>
	<div class="mt-4">
		<h2>{{ $t(`job-offer.provinces`) }}</h2>
		<div
			v-if="jobOffer && applicantProfile"
			class="mb-4 mobile-overflow-table"
		>
			<table class="table mb-0 table-striped">
				<thead class="thead-dark">
					<tr>
						<th></th>
						<th class="w-34"></th>
						<th class="w-33">
							{{ $t('general.job-offer') }}
						</th>
						<th class="w-33">
							{{ $t('general.applicant-profile') }}
						</th>
					</tr>
				</thead>
				<tr>
					<th :class="getProvinceMatch()" width="50">
						<Icon
							class="w-5"
							:icon="[
								'far',
								getProvinceMatch() === 'matched'
									? 'check'
									: 'times'
							]"
						/>
					</th>
					<th></th>
					<td>{{ jobOfferLocationLabel || '?' }}</td>
					<td>{{ applicantProfileLocationLabel || $t('province.flexible') }}</td>
				</tr>
			</table>
		</div>
		<div
			v-else-if="jobOffer && jobOfferLocationLabel"
			class="px-4 py-2 mb-2 mr-2 border d-inline-block rounded-pill"
		>
			<Icon :icon="['far', 'map-marker-alt']" class="mr-1" />{{
				jobOfferLocationLabel
			}}
		</div>
		<div v-else-if="applicantProfile && applicantProfileLocationLabel">
			<div
				class="px-4 py-2 mb-2 mr-2 border d-inline-block rounded-pill"
			>
				<Icon :icon="['far', 'map-marker-alt']" class="mr-1" />
				{{ applicantProfileLocationLabel }}
			</div>
		</div>
	</div>
</template>

<script>
import Icon from '~/components/ui/common/Icon'
import { formatLocation, locationsOverlap } from '~/utils/location'

export default {
	components: {
		Icon
	},
	props: ['jobOffer', 'match', 'applicantProfile'],
	computed: {
		jobOfferLocationLabel() {
			return formatLocation(this.jobOffer, {
				localeColumn: this.$getLocaleDbColumn('name')
			})
		},
		applicantProfileLocationLabel() {
			return formatLocation(this.applicantProfile, {
				localeColumn: this.$getLocaleDbColumn('name')
			})
		}
	},
	methods: {
		getProvinceMatch() {
			if (!this.jobOffer || !this.applicantProfile)
				return 'not-matched'

			return locationsOverlap(this.jobOffer, this.applicantProfile)
				? 'matched'
				: 'not-matched'
		}
	}
}
</script>
